import { ApiResponseModel } from './api-response.model';
import { HttpResponse } from '@angular/common/http';

export class ResponseModel<T> {
    public nativeResponse: HttpResponse<T>;
    public model: T;
    public body: ApiResponseModel<any> | any | T;
    public errorMessage: string;
}
